import {
    OfferSummaryCard,
    createOfferSummaryCard,
} from '@vfde-brix/ws10/offer-summary-card';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { getCMSConfig } from '../util/cms';
import { NonBookableKeys } from '../interface';

/**
 * Create Non-Bookable component.
 * @param {HtmlId} id - Wrapper ID of the element.
 * @returns {OfferSummaryCard|null} OfferSummaryCard component or null if element with given id is not found.
 */
export const mountNonBookableCard = (id: HtmlId) =>
    createComponentById(createOfferSummaryCard, id, NO_PATTERN_BUSINESS_LOGIC);

/**
 * Update every Non-Bookable related components.
 * @param {OfferSummaryCard|null} offerSummaryCard - OfferSummaryCard component or null.
 * @param {string} cmsKey - Cms key that contains the text.
 */
export const updateNonBookableCard = (
    offerSummaryCard: OfferSummaryCard | null,
    cmsKey: NonBookableKeys,
) => {
    const cmsConfig = getCMSConfig().nonBookableCard[cmsKey];

    if (cmsConfig) {
        offerSummaryCard?.updateHeadline({
            stdContent: cmsConfig.headline,
        });
        offerSummaryCard?.updateSubline([cmsConfig.subline]);
        offerSummaryCard?.updateButtons(cmsConfig.button ? [{
            stdContent: cmsConfig.button.text,
            linkHref: cmsConfig.button.link,
            optTarget: cmsConfig.button.optTarget,
        }] : []);
    }
};
